/** PDP: switches the action zone on the checked variant's availability — add-to-cart when available, Klaviyo « Back in Stock » trigger otherwise; both are server-rendered in each zone and merely hidden, and the variant id and `?variant=` URL are kept current since Klaviyo reads them on click. */
(function () {
  const form = document.querySelector("product-form-component form");
  if (!form) return;

  // Plusieurs zones dans le form (colonne info + barre sticky mobile) : on
  // synchronise tous les boutons d'ajout et tous les déclencheurs Klaviyo.
  const addButtons = form.querySelectorAll("[data-add-to-cart]");
  const bisTriggers = form.querySelectorAll("[data-klaviyo-bis]");
  if (!addButtons.length && !bisTriggers.length) return;

  // Blocks rendered once PER VARIANT server-side (delivery estimate, pay in 3, remaining stock): only the checked variant's is shown, so they update without a reload and vanish on their own when nothing was rendered.
  const variantScopedAttrs = ["data-variant-shipping", "data-variant-installment", "data-variant-remaining"];
  const variantScopedNodes = variantScopedAttrs.map(function (attr) {
    return { attr: attr, nodes: form.querySelectorAll("[" + attr + "]") };
  });

  // Reflects the current variant in the URL (?variant=ID) so Klaviyo opens on the right one; replaceState keeps the back button clean.
  function updateVariantUrl(variantId) {
    try {
      const url = new URL(window.location.href);
      url.searchParams.set("variant", variantId);
      history.replaceState({}, "", url.toString());
    } catch (e) {
      /* Contexte sans URL exploitable : non bloquant, on ignore. */
    }
  }

  function update(fromUser) {
    // Pas de radio coché ⇒ produit mono-variante (input hidden) : l'état rendu
    // par le serveur fait foi, aucune bascule nécessaire.
    const checked = form.querySelector('input[name="id"]:checked');
    if (!checked) return;

    const available = checked.dataset.available !== "false";
    const variantId = checked.value;

    addButtons.forEach(function (button) {
      button.hidden = !available;
      // type="button" quand masqué → n'agit pas comme submit par défaut du form.
      button.type = available ? "submit" : "button";
    });

    bisTriggers.forEach(function (trigger) {
      trigger.hidden = available;
      trigger.dataset.variantId = variantId;
    });

    variantScopedNodes.forEach(function (group) {
      group.nodes.forEach(function (node) {
        node.hidden = node.getAttribute(group.attr) !== variantId;
      });
    });

    // The URL is only touched on load when the variant is unavailable (trigger visible); on interaction it always follows the chosen variant.
    if (fromUser || !available) updateVariantUrl(variantId);
  }

  form.addEventListener("change", function (event) {
    if (event.target && event.target.name === "id") update(true);
  });

  update(false);
})();
